<template>
    <!-- <v-card color="grey lighten-2"> -->
    <!-- Container para Información: -->
    <v-container>
        <v-layout row justify-space-around>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 xs11 elevation-6>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                        <v-layout row justify-space-between>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold teal--text text--lighten-2"
                                >{{ $t('title')}}</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon color="teal lighten-1">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('btn-cerrar')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider class="teal lighten-1"></v-divider>
                        <v-layout row justify-space-around>
                            <v-flex xs12 class="text-center">
                                <iframe
                                    id="player"
                                    allowfullscreen="1"
                                    allow="autoplay; encrypted-media"
                                    title="YouTube video player"
                                    src="https://www.youtube.com/embed/_UaCfVAbe1A"
                                    :width="playerDimensions.width"
                                    :height="playerDimensions.height"
                                    frameborder="0"
                                ></iframe>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- </v-card> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'GuiaInterpretacion',
    data() {
        return {};
    },
    created() {},
    methods: {
        onClose() {
            this.showGuiaInterpretacionTxt = false;
        }
    },
    computed: {
        ...mapGetters(['waitCursor']),
        showGuiaInterpretacionTxt: {
            get() {
                return this.$store.getters.showGuiaInterpretacionTxt;
            },
            set(showGuiaInterpretacionTxt) {
                this.$store.dispatch(
                    'updateShowGuiaInterpretacionTxt',
                    showGuiaInterpretacionTxt
                );
            }
        },
        playerDimensions() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '380';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '520';
            } else if (this.$vuetify.breakpoint.md) {
                width = '620';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '720';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '820';
            }
            var height = width * 0.6;
            var dimensions = {
                width: width,
                height: height
            };
            return dimensions;
        }
    }
};
</script>

<i18n>
{
    "es": {
        "title": "Guía de Interpretación"
    },
    "en": {
        "title": "Interpretation Guide"
    }

}
</i18n>

<style scoped>
.sub-window {
    /* background: rgba(0, 77, 64, 0.6); */
    background: rgba(26, 32, 38, 0.8);
}
</style>